import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'

import { Box, Button, Dialog, Grid, Tooltip, useTheme } from '@mui/material'
import { Add } from '@mui/icons-material'

import { useGET_groupCourseByIdQuery, usePUT_addTeacherToGroupCourseMutation } from 'redux/api/groupCoursesApi'
import { useGET_teacherProfileSelectQuery } from 'redux/api/teachersApi'
import { useGET_courseByIdQuery } from 'redux/api/coursesApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import SelectField from 'components/atoms/fields/SelectField'

import formModel, { initialValues, validationSchema } from 'utils/formModels/groupCourseEnrollTeacherModel'
import { crudColorMap, crudIconMap}  from 'utils/helpers'

import { IGroupCourseTeacher } from 'types'

interface IProps {
  id: number
  viewOnly: boolean
}

const GroupCourseEnrollTeacherForm: FC<IProps> = ({ id, viewOnly }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const action = 'edit';

  const [open, setOpen] = useState(false)
  const [enrollTeacher, {isLoading}] = usePUT_addTeacherToGroupCourseMutation()
  const { teacher } = formModel()

  const { data: groupCourse } = useGET_groupCourseByIdQuery(id.toString())
  const { data: course } = useGET_courseByIdQuery(groupCourse.course.id.toString())

  return (
    <Box 
      className="transparent-background"
      sx={{
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    >

      <Tooltip title={`${t('common.add')}`} arrow placement='top'>
        <Button
          variant='contained'
          color='success'
          aria-haspopup='true'
          onClick={() => setOpen(true)}
          disableElevation
          sx={{
            '&:hover': { background: theme.palette.success.main, border: 'none', '& svg': { color: '#000' } },
            height: '2.75rem',
            padding: '5',
            minWidth: 'auto',
            marginRight: '0.2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
          }}
        >
          <Add
            sx={{ fontSize: '2rem', lineHeight: '1' }}
          />
          <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                      'common.enroll-teacher',
                    )}`}</span>

        </Button>
      </Tooltip>


      <Dialog
                onClose={() => setOpen(false)}
                open={open}
                fullWidth
                maxWidth='md'
                PaperProps={{
                  sx: {
                    margin: 0,
                    padding: 3,
                    width: { xs: '400px', md: '400px' },
                    maxWidth: { xs: '100vw', md: '80vw' },
                    background: theme.palette.background.default,
                  },
                }}
              >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const data: IGroupCourseTeacher = {
              id: id.toString(),
              teacher_id: values.teacher.id.toString(),
            }
            enrollTeacher(data)
          }}
        >
          <Form>
            <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>

              <Grid item xs={12} lg={12}>
                { course && <SelectField
                    fieldProps={{ ...teacher }}
                    apiCall={useGET_teacherProfileSelectQuery}
                    filters={ {subject: course.subject.id} }
                    disabled={viewOnly} 
                  />
                }
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex' }}>
                  <Button
                    variant='outlined'
                    color='black'
                    onClick={() => setOpen(false)}
                    sx={{ minHeight: '2.5rem', width: '10rem' }}
                  >
                    <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                    {`${t('common.back')}`}
                  </Button>
                  <SubmitButton
                    color={crudColorMap[action]}
                    text={`${t('common.enroll')}`}
                    icon={crudIconMap[action]}
                    sx={{ width: '10rem' }}
                     isLoading={isLoading}
                  />
                </Box>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Dialog>
    </Box>
  )
}
export default GroupCourseEnrollTeacherForm
